import React, { useRef, useState } from 'react'
import PropTypes from "prop-types"
import { useOutletContext } from "react-router-dom"

import wait from "@helpers/wait"
import Drawer from "@components/Page/Drawer"
import { HEADER_HEIGHT, DRAWER_WIDTH3 } from "@components/constants"

import Title from "./Title"
import SignInAsButton from "./SignInAsButton"
import InvestorDrawerTabs from "./InvestorDrawerTabs"
import AccountUpdateDrawer from "../AccountUpdateDrawer"


const InvestorDrawer = ({ drawer, onClose, onAfterUpdate }) => {
  const updateDrawer = useRef({})

  const { useAccount } = useOutletContext()

  const [ accountId, setAccountId ] = useState()
  const account = useAccount(accountId)

  const onOpen = id =>
    setAccountId(id)

  const onDrawerClose = () => {
    wait(300).then(() => setAccountId())
    onClose()
  }

  const openAccountUpdateDrawer = () =>
    updateDrawer.current.open()

  const styles = {
    body: { paddingTop: 0, paddingBottom: 0 },
    header: { minHeight: HEADER_HEIGHT + 1 }
  }

  const title = <Title account={account} />

  const extra = <SignInAsButton account={account} />

  return (
    <Drawer
      extra={extra}
      title={title}
      width={DRAWER_WIDTH3}
      onOpen={onOpen}
      drawer={drawer}
      styles={styles}
      onClose={onDrawerClose}
      destroyOnClose={true}
    >
      {
        account && (
          <>
            <InvestorDrawerTabs
              account={account}
              openAccountUpdateDrawer={openAccountUpdateDrawer}
            />

            <AccountUpdateDrawer
              drawer={updateDrawer}
              account={account}
              onAfterUpdate={onAfterUpdate}
            />
          </>
        )
      }
    </Drawer>
  )
}

InvestorDrawer.propTypes = {
  drawer: PropTypes.shape().isRequired,
  onClose: PropTypes.func,
  onAfterUpdate: PropTypes.func,
}

InvestorDrawer.defaultProps = {
  onClose: () => {},
  onAfterUpdate: () => {},
}

export default InvestorDrawer
